import React from 'react'
import styled from '@emotion/styled'

const Line = styled.div`
  height: 1px;
  background: var(--foreground);
  opacity: 0.5;
  width: 80vw;
    max-width: 800px;
  margin: 50px 0;
`

const BreakLine = () => {
  return <Line></Line>
}

export default BreakLine